var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessageLines } from "@fortawesome/pro-regular-svg-icons";
import Dropdown from "@mui/joy/Dropdown";
import MenuButton from "@mui/joy/MenuButton";
import Menu from "@mui/joy/Menu";
import MenuItem from "@mui/joy/MenuItem";
import { useGetModuleListQuery, useMarkAsReadAlertMutation } from "@/store/api";
import { useAppSelector } from "@/hooks/store";
import { getCurrentUser } from "@/store/utils/selectors/userSelector";
import { useNavigate } from "react-router-dom";
import { slotDirection } from "@/utils/funcs";
import { SlotDirection } from "@/utils/types/layout";
import AlertMessage from "./message";
import { useTranslation } from "react-i18next";
export default function AlertWidget(_a) {
    var _this = this;
    var widget = _a.widget;
    var currentUser = useAppSelector(getCurrentUser) || {};
    var markAsRead = useMarkAsReadAlertMutation()[0];
    var navigate = useNavigate();
    var _b = useState([]), records = _b[0], setRecords = _b[1];
    var t = useTranslation(["common"]).t;
    var whereRule = [
        {
            operator: "and",
            rules: [
                {
                    field: "assigned_user_id",
                    operator: "eq",
                    value: typeof currentUser === "string" ? currentUser : currentUser.id,
                },
                {
                    field: "is_read",
                    operator: "eq",
                    value: 0,
                },
            ],
        },
    ];
    var _c = useGetModuleListQuery({
        table: "Alerts",
        params: {
            sorted: [
                {
                    name: "date_entered",
                    direction: "descending",
                },
            ],
            where: whereRule,
            count: false,
        },
    }), recordResponse = _c.data, refetch = _c.refetch;
    var _d = useState({}), fisrtRecord = _d[0], setFirstRecord = _d[1];
    var _e = useState([]), lastRecord = _e[0], setLastRecord = _e[1];
    useEffect(function () {
        var response = (recordResponse === null || recordResponse === void 0 ? void 0 : recordResponse.data) || {};
        var rec = (response === null || response === void 0 ? void 0 : response.records) || {};
        setRecords(rec);
        // Séparer records dans 2 tableaux différent
        if (rec && Object.values(rec).length > 0) {
            var recArray = Object.values(rec);
            setFirstRecord(recArray.slice(0, 1));
            setLastRecord(recArray.slice(1));
        }
    }, [recordResponse]);
    var addNotification = function () { };
    var counter = (records === null || records === void 0 ? void 0 : records.length) || 0;
    var removeAlert = function (eid, nav, url) {
        if (nav === void 0) { nav = false; }
        if (url === void 0) { url = ""; }
        return __awaiter(_this, void 0, void 0, function () {
            var newRecords, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newRecords = Object.values(records).filter(function (item) {
                            return item.id !== eid;
                        });
                        setRecords(newRecords);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, markAsRead({
                                id: eid,
                            }).then(function () {
                                if (nav && url !== "") {
                                    refetch();
                                    var params = new URLSearchParams(url);
                                    var mod = params.get("module");
                                    var rec = params.get("record");
                                    navigate("/modules/".concat(mod, "/DetailView/").concat(rec));
                                }
                            })];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Failed to make as read:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        var interval = setInterval(function () {
            refetch && refetch();
        }, 60000);
        return function () { return clearInterval(interval); };
    }, [recordResponse]);
    var direction = widget.slot
        ? slotDirection(widget.slot)
        : SlotDirection.VERTICAL;
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    return (_jsx("div", __assign({ className: "overflow-hidden dark:text-white" }, { children: direction === "HORIZONTAL" ? (_jsxs(Dropdown, { children: [_jsx(MenuButton, __assign({ sx: {
                        border: "none",
                        width: "50px",
                        "&:hover": {
                            background: "none",
                        },
                    } }, { children: _jsxs("a", __assign({ href: "#", onClick: addNotification, className: "relative" }, { children: [_jsx(FontAwesomeIcon, { icon: faMessageLines, size: "xl", title: "Notification" }), counter > 0 && !isEditingLayout && (_jsx("span", __assign({ className: "flex absolute top-[-7px] right-[-13px] items-center justify-center rounded-full bg-red-500 w-full text-white" }, { children: counter })))] })) })), records && (_jsx(Menu, __assign({ sx: {
                        background: "var(--colors-bg-default)",
                        width: "15%",
                        maxHeight: "90%",
                        overflow: "auto",
                    } }, { children: records && counter > 0 ? (Object.values(records).map(function (item) { return (_jsx("div", __assign({ className: "" }, { children: _jsx(MenuItem, __assign({ sx: {
                                background: "var(--colors-widget)",
                                margin: "0 0 4px 0",
                                cursor: "auto",
                            } }, { children: _jsx(AlertMessage, { alert: item, removeAlert: removeAlert }) })) }))); })) : (_jsxs("div", __assign({ className: "pl-2" }, { children: [t("app.LBL_NOTIFICATIONS_NONE"), " ..."] }))) })))] })) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "flex justify-center mt-1" }, { children: _jsxs(Dropdown, { children: [counter > 1 ? (_jsx(MenuButton, __assign({ sx: { border: "none", width: "50px" } }, { children: _jsxs("a", __assign({ href: "#", onClick: addNotification, className: "relative" }, { children: [_jsx(FontAwesomeIcon, { icon: faMessageLines, size: "xl" }), counter > 0 && !isEditingLayout && (_jsx("span", __assign({ className: "flex absolute top-[-7px] right-[-13px] items-center justify-center rounded-full bg-red-500 w-full text-white" }, { children: counter })))] })) }))) : (_jsx("div", __assign({ className: "flex justify-center mt-1" }, { children: _jsxs("a", __assign({ href: "#", onClick: addNotification, className: "relative" }, { children: [_jsx(FontAwesomeIcon, { icon: faMessageLines, size: "xl" }), counter > 0 && !isEditingLayout && (_jsx("span", __assign({ className: "flex absolute top-[-7px] right-[-13px] items-center justify-center rounded-full bg-red-500 w-full text-white" }, { children: counter })))] })) }))), lastRecord && (_jsx(Menu, __assign({ sx: {
                                    background: "var(--colors-bg-default)",
                                    width: "15%",
                                    maxHeight: "90%",
                                    overflow: "auto",
                                } }, { children: lastRecord.length > 0 &&
                                    Object.values(lastRecord).map(function (item) { return (_jsx("div", __assign({ className: "" }, { children: _jsx(MenuItem, __assign({ sx: {
                                                background: "var(--colors-widget)",
                                                margin: "0 0 4px 0",
                                                cursor: "auto",
                                            } }, { children: _jsx(AlertMessage, { alert: item, removeAlert: removeAlert }) })) }))); }) })))] }) })), fisrtRecord && (_jsx("div", __assign({ className: "mt-1 bg-[var(--colors-bg-default)] overflow-y-auto overflow-x-hidden mx-3 mb-3 rounded-md" }, { children: fisrtRecord && counter > 0 ? (Object.values(fisrtRecord).map(function (item) { return (_jsx(AlertMessage, { alert: item, isVertical: true, removeAlert: removeAlert })); })) : (_jsxs("div", __assign({ className: "pl-2" }, { children: [t("app.LBL_NOTIFICATIONS_NONE"), " ..."] }))) })))] })) })));
}
widgetsDictionary.register("widget/alert", {
    name: "Notification alert",
    display: AlertWidget,
    selectable: true,
});
